export default "__VITE_ASSET__UiV$kmLr__"